import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import jsonFormatter from './json';
import _ from '../../utils';

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    window.JSON = _.extend(JSON, jsonFormatter);
  },
};
